<template>
    <div class="form-group row">
        <label class="col-12 col-md-2 col-form-label">免許証の有効期限</label>
        <div class="col-12 col-md px-1 py-1">
            <select class="form-control" v-model="selectedJapaneseCalendar">
                <option v-for="japaneseCalendar in japaneseCalendars" :key="japaneseCalendar" :value="japaneseCalendar">{{ japaneseCalendar }}</option>
            </select>
        </div>
        <div class="col-12 col-md px-1 py-1">
            <select class="form-control" v-model="selectedYear">
                <option v-for="year in years" :key="year" :value="year">{{ year }}年</option>
            </select>
        </div>
        <div class="col-12 col-md px-1 py-1">
            <select class="form-control" v-model="selectedMonth">
                <option v-for="month in months" :key="month" :value="month">{{ month }}月</option>
            </select>
        </div>
        <div class="col-12 col-md px-1 py-1">
            <select class="form-control" v-model="selectedDay">
                <option v-for="day in days" :key="day" :value="day">{{ day }}日</option>
            </select>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        data () {
            return {
                japaneseCalendars: ['平成', '令和'],
                years: [],
                months: [],
                days: [],

                selectedJapaneseCalendar: '平成',
                selectedYear: 0,
                selectedMonth: 1,
                selectedDay: 1
            }
        },
        created: function () {
            // 初期化
            this.years = this.range(moment().year() - 1988, 36); // 平成36年表記まで存在するため
            this.months = this.range(1, 12);
            this.days = this.range(1, 31);

            this.selectedYear = moment().year() - 1988;
        },
        methods: {
            range: function(start, end) {
                return [...Array(end + 1).keys()].slice(start);
            },
            emitParentComponent: function() {
                let year = null;
                if (this.selectedJapaneseCalendar === '平成') {
                    year = this.selectedYear + 1988;
                }
                if (this.selectedJapaneseCalendar === '令和') {
                    year = this.selectedYear + 2018;
                }
                const date = moment({years: year, months: this.selectedMonth - 1, days: this.selectedDay});
                this.$emit("add", date);
            },
        },
        watch: {
            // 和暦によって年の表示を切り替える
            // TODO: 6年以上前の期間は表示しないようにする
            selectedJapaneseCalendar: function (newSelectedJapaneseCalendar) {
                if (newSelectedJapaneseCalendar === '平成') {
                    this.years = this.range(moment().year() - 1988, 36); // 平成36年表記まで存在するため
                    this.selectedYear = moment().year() - 1988;
                }
                if (newSelectedJapaneseCalendar === '令和') {
                    this.years = this.range(1, moment().year() - 2018 + 5); // 免許証の期限は最大5年
                    this.selectedYear = 1;
                }
            },
            // 月によって日の表示を切り替える
            selectedMonth: function (newSelectedMonth) {
                if (newSelectedMonth === 2) {
                    this.days = this.range(1, 28);
                } else {
                    this.days = [1, 3, 5, 7, 8, 10, 12].includes(newSelectedMonth) ? this.range(1, 31) : this.range(1, 30);
                }
            }
        },
    }
</script>